module.exports = __webpack_public_path__ + "img/MG_4630-scaled.48142964.jpg";